import React from "react";

import Sunset from "../components/Sunset";

import "../styles/Press.css";

const Press = () => {
    return (
        <div>
            <Sunset />
            <div className="press-link-container">
                <a
                    className="press-link"
                    href="http://crazyhorsenc.com/jeremy-jones-band-star-born-bayou/"
                >
                    *JEREMY JONES BAND: (A STAR IS) BORN ON THE BAYOU
                </a>
                <a
                    className="press-link"
                    href="https://www.gottagrooverecords.com/2015/02/record-highlight-jeremy-jones/"
                >
                    *GOTTA GROOVE RECORDS: RECORD HIGHLIGHT-JEREMY JONES
                </a>
            </div>
        </div>
    );
};

export default Press;



// WEBPACK FOOTER //
// ./src/components/Press.js